import BaseModel from "./base/baseModel";

export default class PrescritorEspecialidadeModel extends BaseModel {
    id?: number = null;
    prescritorId?: number = null;
    especialidadeId?: number = null;
    especialidadeDescricao: string = null;
}
